import { useCallback, useState } from "react";
import { googleAddressValidate } from "../../../api/googleApi/AddressValidate";
import { areEquivalent, buildGoogleRequest } from "./addressValidationHelpers";

export default function useGoogleAddressValidation() {
  const [isOpen, setIsOpen] = useState(false);
  const [userAddress, setUserAddress] = useState(null);
  const [suggestedAddress, setSuggestedAddress] = useState(null);

  const validateAndMaybeSuggest = useCallback(async (address, options = {}) => {
    const { alwaysReview = false } = options || {};
    if (!address) return true;
    const request = buildGoogleRequest(address);
    try {
      const url = "utils/validate-address";
      const resp = await googleAddressValidate(url, request);
      if (!resp.ok) return true;
      const data = await resp.json();
      const suggested = { ...data.address, fromDate: "", toDate: "" };
      if (!alwaysReview && areEquivalent(address, suggested)) return true;
      setUserAddress(address);
      setSuggestedAddress(suggested);
      setIsOpen(true);
      return false;
    } catch (_e) {
      return true;
    }
  }, []);

  const acceptSuggestedAndApply = useCallback((applyFn) => {
    try {
      if (typeof applyFn === "function") applyFn();
    } finally {
      setIsOpen(false);
    }
  }, []);

  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    userAddress,
    suggestedAddress,
    validateAndMaybeSuggest,
    acceptSuggestedAndApply,
  };
}
